import { Component } from 'react'
import { AlertTriangle, RotateCw } from 'lucide-react'
import Button from './ui/Button.jsx'

/** Catches render/lifecycle errors anywhere below it so one broken page
 *  never blank-screens the whole dashboard — shows a recoverable error
 *  screen instead. Class component: React 18 error boundaries require it,
 *  there is no hook equivalent. */
export default class ErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('FlipStudio dashboard error:', error, info)
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <div className="min-h-screen flex items-center justify-center px-6">
        <div className="max-w-[380px] text-center">
          <div className="w-14 h-14 rounded-full bg-danger/15 text-danger flex items-center justify-center mx-auto mb-5">
            <AlertTriangle size={26} />
          </div>
          <h1 className="font-display font-bold text-[19px] mb-2">Something went wrong</h1>
          <p className="text-muted text-[13.5px] mb-6 leading-relaxed">
            This page hit an unexpected error. Your other work is safe — reloading usually fixes it.
            If it keeps happening, let JLR Dev know.
          </p>
          <Button icon={RotateCw} className="mx-auto" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </div>
      </div>
    )
  }
}
